import React from 'react'
import Utils from '../../../../../../../../../utils/Utils'
import Asset from '../../../../../../../../../requests/apa/Asset'
import './_styles.scss'

function PlayerCardWithEvent (props) {
  var playerName = props.playerName
  var photoUrl = props.photoUrl
  var topLeftIconUrl = props.topLeftIconUrl
  var topRightIconUrl = props.topRightIconUrl
  var bottomRightIconUrl = props.bottomRightIconUrl
  var bottomRightIconLabel = props.bottomRightIconLabel
  var bottomLeftIconUrl = props.bottomLeftIconUrl
  var playerMovements = props.playerMovements || []
  var goals = props.goals || 0;
  var borderColor = props.borderColor;

  const playerLastName = playerName.split(' ').slice(-1).join(' ');

  return (
    <div className='player-card-with-event'>
      <img
        className='player-card-with-event__photo'
        style={{borderColor: borderColor}}
        src={photoUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = Asset.get('eventodeportivo_placeholder_imagen_jugador_2');
        }}
        alt={playerName}
      />
      {topLeftIconUrl && (
        <img
          className='player-card-with-event__icon player-card-with-event__icon--top-left'
          src={topLeftIconUrl}
          alt=''
        />
      )}
      {topRightIconUrl && (
        <img
          className='player-card-with-event__icon player-card-with-event__icon--top-right'
          src={topRightIconUrl}
          alt=''
        />
      )}
      {bottomRightIconUrl && (
        <div className='player-card-with-event__bottom-right-wrapper'>
          <img
            className='player-card-with-event__icon player-card-with-event__icon--bottom-right'
            src={bottomRightIconUrl}
            alt=''
          />
          {
            goals >= 2 && (
              <div className='player-card-with-event__bottom-right-label-container'>
                <span className='player-card-with-event__bottom-right-label'>{goals}</span>
              </div>
            )
          }
        </div>
      )}
      {bottomLeftIconUrl && (
        <img
          className='player-card-with-event__icon player-card-with-event__icon--bottom-left'
          src={bottomLeftIconUrl}
          alt=''
        />
      )}
      <p className='player-card-with-event__name'>{Utils.cutPlayerString(playerLastName, 10)}</p>
    </div>
  )
}

export default PlayerCardWithEvent



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/PlayerCardWithEvent/index.jsx